// extracted by mini-css-extract-plugin
module.exports = {"warnLabel":"outdated_warning-module_warnLabel_ba030","warnBox":"outdated_warning-module_warnBox_24bca"};